import * as React from "react";
import { Modal } from "react-bootstrap";

import FormBuilder from "./FormBuilder";
import "./FormBuilderDialog.scss";

export default function FormBuilderDialog({ open, onClose, form, ...props }) {
	const [valid, setValid] = React.useState(false);
	const [organizedValues, setOrganizedValues] = React.useState({});
	const [showWarnings, setShowWarnings] = React.useState(false);

	const changeHandler = e => {
		setValid(Boolean(e.valid));
		setOrganizedValues(e.organizedValues);
	};
	
	const stop_events = e => e.stopPropagation();

	return (
		<>
			<div
				onKeyDown={stop_events}
				onClick={stop_events}
				onFocus={stop_events}
				onMouseOver={stop_events}
			>
				<Modal
					className={
						["_boss dialog form-builder-dialog", valid ? "valid" : "invalid"].join(" ")
					}
					show={open}
					onHide={onClose}
					backdrop="static"
					keyboard={false} //disables closing on outside click and keyboard esc close
					size="lg"
					aria-labelledby="contained-modal-title-vcenter"
					centered
					enforceFocus={false}
					fullscreen={true}
				>
					<Modal.Header closeButton>
						<Modal.Title>
							<h4 className="p-2">{form?.title}</h4>
						</Modal.Title>
					</Modal.Header>
					<Modal.Body>
						<FormBuilder
							{...props}
							open={open}
							form={form}
							onChange={changeHandler}
							hideTitle={true}
							showWarnings={showWarnings}
						/>
					</Modal.Body>
				</Modal>
			</div>
		</>
	);
}
